import React from "react";
import { Container } from "react-bootstrap";
import "./FollowUs.scss";
import CustomButton from "../../shared/custom-button/custom-button";
import { NavLink } from "react-router-dom";

const Icons = {
  Strategy: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="tag-icon"
    >
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
      <polyline points="17 6 23 6 23 12" />
    </svg>
  ),
  Governance: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="tag-icon"
    >
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  ),
  Finance: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="tag-icon"
    >
      <line x1="18" y1="20" x2="18" y2="10" />
      <line x1="12" y1="20" x2="12" y2="4" />
      <line x1="6" y1="20" x2="6" y2="14" />
    </svg>
  ),
  CapitalReadiness: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="tag-icon"
    >
      <path d="M3 21h18" />
      <path d="M5 21V7l7-3 7 3v14" />
      <path d="M9 21v-4" />
      <path d="M15 21v-4" />
    </svg>
  ),
};

const FollowUs = () => {
  const tags = [
    { label: "Strategy", icon: Icons.Strategy },
    { label: "Governance", icon: Icons.Governance },
    { label: "Finance", icon: Icons.Finance },
    { label: "Capital Readiness", icon: Icons.CapitalReadiness },
  ];

  return (
    <section className="follow-us-section">
      <div className="follow-us-content">
        <span className="subtitle">Follow Us</span>
        <h2 className="title">Insights That Shape Growth</h2>
        <p className="description">
          Stay connected with Amicus Growth Advisors for perspectives on
          strategy, governance, finance, and capital readiness. Follow us on
          LinkedIn for thought leadership, market insights, ESG updates, and
          firm announcements.
        </p>

        <div className="tags-container">
          {tags.map((tag, index) => {
            const Icon = tag.icon;
            return (
              <div key={index} className="tag">
                <Icon />
                <span className="tag-text">{tag.label}</span>
              </div>
            );
          })}
        </div>
        <CustomButton
          as={NavLink}
          to={"https://www.linkedin.com/company/amicusllp?originalSubdomain=in"}
        >
          Follow Amicus on LinkedIn
        </CustomButton>
      </div>
    </section>
  );
};

export default FollowUs;
